// extracted by mini-css-extract-plugin
export default {"titleContainer":"DataPrivacyModal_titleContainer__AmuFA","modalTitle":"DataPrivacyModal_modalTitle__Pnmki"};